import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CalService } from '../../../auth/cal.service';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  static settings: any;

  constructor(private readonly calService: CalService) {}

  load() {
    return new Promise<void>((resolve, reject) => {
      AppConfigService.settings = environment.calSettings;
      AppConfigService.settings.apiUrl = environment.apiUrl;
      AppConfigService.settings.baseUrl = environment.baseUrl;

      Promise.all([
        this.calService.signIn().toPromise(),
        this.calService.getToken().toPromise(),
        this.calService.getUserImpersonationToken().toPromise(),
      ])
        .then(() => resolve())
        .catch((err) => reject(err));
    });
  }
}
